import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'arrayTemplateFilter' })
export class ArrayTemplateFilterPipe implements PipeTransform {
    transform(template,number) {
        let currentOrderedValues = template.templateContent.buttons.action.websiteUrl
        return currentOrderedValues.filter((item)=> item.url.includes("{{1}}"))[number].text;
    }
}